import React, { useState } from "react";
import { Ban, Link2, Save } from "lucide-react";
import { toast } from "sonner";
import { apiClient, formatApiError } from "@/lib/auth";
import { Btn, Choice, Field, Modal, SecretBox, inputCls, when } from "./kit";

export const ResidentEditDialog = ({ resident, meta, onClose, onSaved }) => {
  const [f, setF] = useState({ ...resident, status_reason: "" });
  const [link, setLink] = useState("");
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e?.target ? e.target.value : e }));
  const run = async (fn, ok) => { try { await fn(); toast.success(ok); onSaved(); } catch (e) { toast.error(formatApiError(e)); } };

  const save = () => {
    const body = Object.fromEntries(["first_name", "last_name", "preferred_name", "status"]
      .filter((k) => (f[k] ?? "") !== (resident[k] ?? "")).map((k) => [k, f[k]]));
    if (body.status) body.status_reason = f.status_reason;
    if (!Object.keys(body).length) return toast.message("Nothing changed");
    run(async () => { await apiClient.patch(`/console/residents/${resident.id}`, body); onClose(); }, "Saved");
  };
  const mint = () => run(async () => {
    const { data } = await apiClient.post(`/console/residents/${resident.id}/portal-link`);
    setLink(`${window.location.origin}${data.path}`);
  }, "New portal link issued");
  const revoke = () => window.confirm("Revoke this resident's portal link?") &&
    run(() => apiClient.delete(`/console/residents/${resident.id}/portal-link`), "Portal link revoked");

  return (
    <Modal open onClose={onClose} title={`Edit resident · ${resident.first_name} ${resident.last_name}`} testId="resident-edit-dialog">
      <div className="space-y-4">
        <div className="grid sm:grid-cols-3 gap-3">
          {["first_name", "last_name", "preferred_name"].map((k) => (
            <Field key={k} label={k.replace("_", " ")}><input data-testid={`resident-${k}`} className={inputCls} value={f[k] || ""} onChange={set(k)} /></Field>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <Field label="Program status"><Choice testId="resident-status" value={f.status} onChange={set("status")} options={meta.resident_statuses} /></Field>
          {f.status !== resident.status && (
            <Field label="Reason for status change (required)"><input data-testid="resident-status-reason" className={inputCls} value={f.status_reason} onChange={set("status_reason")} /></Field>
          )}
        </div>
        <div className="p-3 border border-white/10 rounded-sm space-y-2">
          <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/50">Portal access (magic link)</div>
          <div className="text-sm text-white/70" data-testid="resident-portal-state">
            {resident.portal_active ? `Active · issued ${when(resident.portal_created_at)} · last used ${when(resident.portal_last_used_at)}` : "No active link"}
          </div>
          <div className="flex gap-2">
            <Btn tone="muted" data-testid="resident-mint-link" onClick={mint}><Link2 size={12} /> {resident.portal_active ? "Replace link" : "Issue link"}</Btn>
            {resident.portal_active && <Btn tone="red" data-testid="resident-revoke-link" onClick={revoke}><Ban size={12} /> Revoke</Btn>}
          </div>
          {link && <SecretBox label="Portal link" value={link} testId="resident-portal-link" />}
        </div>
        <div className="flex justify-end"><Btn data-testid="resident-save" onClick={save}><Save size={12} /> Save changes</Btn></div>
      </div>
    </Modal>
  );
};
